// extracted by mini-css-extract-plugin
export default {"ScreenShotButton":"ScreenShotButton_ScreenShotButton__OalOD","icon":"ScreenShotButton_icon__MvhKr"};